import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import "./HotelCard.css";

const HotelCard = ({ property }) => {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);

  // Safely check rooms
  const room = property?.rooms && property.rooms.length > 0 ? property.rooms[0] : {};
  const roomDetails = room?.roomDetails || {};
  const images = room?.roomImages?.length ? room.roomImages : property?.images || [];
  const bookingData = JSON.parse(localStorage.getItem("BookingDate"));

  // 🔹 Nights calculate karne ka function
  const calculateNights = (checkIn, checkOut) => {
    if (!checkIn || !checkOut) return 1;
    const start = new Date(checkIn);
    const end = new Date(checkOut);
    const diffTime = end - start;
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };

  const nights = calculateNights(bookingData?.checkIn, bookingData?.checkOut);

  // 🔹 Image slider
  useEffect(() => {
    if (images.length > 1) {
      const timer = setInterval(() => {
        setActiveIndex((prev) => (prev + 1) % images.length);
      }, 3000);
      return () => clearInterval(timer);
    }
  }, [images.length]);

  const nextImage = () => {
    setActiveIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setActiveIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const toSlug = (name) => {
    if (!name) return "unknown";
    return name
      .trim()
      .toLowerCase()
      .replace(/%20/g, "-")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };

  const handleAvailabilityClick = () => {
    navigate(`/property/${toSlug(property.propertyName)}`, { state: { property } });
  };

  // 🔹 Get room price with priority: Discount > Calendar > Nightly
  const getRoomPriceForDate = (room, date) => {
    const checkDate = new Date(date);

    // 1️⃣ Discount check
    if (room.discount?.isDiscountActive && room.discount?.discountPrice != null) {
      return room.discount.discountPrice;
    }

    // 2️⃣ Calendar check
    if (room.calendar?.length > 0) {
      for (const entry of room.calendar) {
        const start = new Date(entry.startDate);
        const end = new Date(entry.endDate);
        if (checkDate >= start && checkDate <= end) {
          if (entry.status === "close") return null; // room closed
          if (entry.status === "open" && entry.price != null) return entry.price;
        }
      }
    }

    // 3️⃣ Fallback nightlyPrice
    return room.nightlyPrice ?? null;
  };

  const price = getRoomPriceForDate(room, bookingData?.checkIn);

  return (
    <div className="hotel-card">
      {/* Image */}
      <div className="hotel-image">
        <img
          src={
            images[activeIndex] ||
            "https://cf.bstatic.com/xdata/images/hotel/square240/728776239.webp"
          }
          alt={property?.propertyName || "Hotel"}
        />
        {images.length > 1 && (
          <>
            <button className="arrow prev" onClick={prevImage}>❮</button>
            <button className="arrow next" onClick={nextImage}>❯</button>
          </>
        )}
        <div className="image-dots">
          {images.slice(0, 5).map((_, i) => (
            <span
              key={i}
              className={`dot ${i === activeIndex ? "active" : ""}`}
              onClick={() => setActiveIndex(i)}
            />
          ))}
        </div>
      </div>

      {/* Details */}
      <div className="hotel-details">
        <h2 className="hotel-title">
          {property?.propertyName || "Hotel Name"}{" "}
          <span className="stars">{"★".repeat(property?.stars || 2)}</span>
        </h2>
        <p className="hotel-location">
          {property?.city || "City"} · <a href="#">Show on map</a>
        </p>

        <div className="room-info">
          <p className="room-name">{roomDetails?.roomName || "Standard Room"}</p>

          {room?.bedroomBeds && (
            <p>
              {Object.entries(room.bedroomBeds)
                .filter(([type, count]) => count > 0)
                .map(([type, count]) => `${count} ${type} bed${count > 1 ? "s" : ""}`)
                .join(", ")}
            </p>
          )}
          {room?.livingRoomBeds && (
            <p>
              {Object.entries(room.livingRoomBeds)
                .filter(([type, count]) => count > 0)
                .map(([type, count]) => `${count} ${type}${count > 1 ? "s" : ""}`)
                .join(", ")}
            </p>
          )}
        </div>

        <div className="features">
          {room?.breakfast?.available && (
            <p className="breakfast">
              {room.breakfast.included
                ? "Breakfast included"
                : `Breakfast available Extra PKR ${room.breakfast.price}`}
            </p>
          )}
          <p className="green">✔ Free cancellation</p>
          <p className="red">
            {/* Only {roomDetails?.noOfRooms || 1} rooms left at this price on our site */}
            Only Few  Rooms left at this price on our site
          </p>
        </div>
      </div>

      {/* Price / Action */}
      <div className="hotel-price">
        {property?.isNew && <span className="badge">New to Yovho.com</span>}

        <p className="nights">
          {nights} night{nights > 1 ? "s" : ""},{" "}
          {bookingData?.adults || 0} adults
          {bookingData?.children > 0 ? `, ${bookingData.children} children` : ""}
          {bookingData?.rooms ? ` · ${bookingData.rooms} room(s)` : ""}
        </p>

        <p className="price">  Start From <br /> PKR {price ?? "N/A"}</p>

        {room.discount?.isDiscountActive && (
          <p className="tax">
            <s>Start From <br />PKR {room?.nightlyPrice}</s> (discount applied: {room.discount.discountPercentage}%)
          </p>
        )}

        {/* <p className="tax">+ PKR {room?.tax || 0} taxes and fees</p> */}
<p className="tax">
  + PKR {Math.round((getRoomPriceForDate(room, bookingData.checkIn) || 0) * (room.tax || 0) / (room.nightlyPrice || 1))} taxes and fees
</p>

        <button
          className="availability-btn"
          onClick={handleAvailabilityClick}
          disabled={price === null} // ❌ disable if room closed
        >
          {price === null ? "Room Closed" : "See availability"}
        </button>
      </div>
    </div>
  );
};

export default HotelCard;
























// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";   // <-- add this

// import "./HotelCard.css";

// const HotelCard = ({ property }) => {
//   const navigate = useNavigate()
//   // Safely check rooms
//   const room = property?.rooms && property.rooms.length > 0 ? property.rooms[0] : {};
//   const roomDetails = room?.roomDetails || {};
//   const images = room?.roomImages?.length ? room.roomImages : property?.images || [];
// const activeDiscount = room?.discount?.isDiscountActive ? room.discount : null;

// const bookingData = JSON.parse(localStorage.getItem("BookingDate"));

// // 🔹 Nights calculate karne ka function
// const calculateNights = (checkIn, checkOut) => {
//   if (!checkIn || !checkOut) return 1; // fallback
//   const start = new Date(checkIn);
//   const end = new Date(checkOut);
//   const diffTime = end - start;
//   return Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // difference in days
// };

// const nights = calculateNights(bookingData?.checkIn, bookingData?.checkOut);


// console.log(activeDiscount)
//   useEffect(() => {
//     if (images.length > 1) {
//       const timer = setInterval(() => {
//         setActiveIndex((prev) => (prev + 1) % images.length);
//       }, 3000);
//       return () => clearInterval(timer);
//     }
//   }, [images.length]);

//    const [activeIndex, setActiveIndex] = useState(0);

//   // Go to next image (optional auto-slide)


// const nextImage = () => {
//     setActiveIndex((prev) => (prev + 1) % images.length);
//   };

//   const prevImage = () => {
//     setActiveIndex((prev) => (prev - 1 + images.length) % images.length);
//   };

// const toSlug = (name) => {
//   if (!name) return "unknown";
//   return name
//     .trim()                 // 🔹 start/end spaces hatao
//     .toLowerCase()
//     .replace(/%20/g, "-")   // %20 ko - se replace
//     .replace(/\s+/g, "-")   // multiple spaces ko -
//     .replace(/-+/g, "-");   // extra dashes ko remove
// };

//     // 🔹 Handle button click → go to detail page
//   const handleAvailabilityClick = () => {
//     navigate(`/property/${toSlug(property.propertyName)}`, { state: { property } });  
//   };

//   return (
    
//     <div className="hotel-card">
//       {/* Image */}
//       <div className="hotel-image">
//         {/* <img
//           src={images[0] || "https://cf.bstatic.com/xdata/images/hotel/square240/728776239.webp?k=25ee42cb01fbb014251ccd37c48f27e9807c1391e10b2e2754457931a42d7402&o="}
//           alt={property?.propertyName || "Hotel"}
//         />
//         <div className="image-dots">
//           {images.slice(0, 5).map((_, i) => (
//             <span key={i} className={`dot ${i === 0 ? "active" : ""}`} />
//           ))}

          
//         </div> */}





//      <img
//           src={
//             images[activeIndex] ||
//             "https://cf.bstatic.com/xdata/images/hotel/square240/728776239.webp"
//           }
//           alt={property?.propertyName || "Hotel"}
//         />

//         {/* Navigation Arrows */}
//         {images.length > 1 && (
//           <>
//             <button className="arrow prev" onClick={prevImage}>
//               ❮
//             </button>
//             <button className="arrow next" onClick={nextImage}>
//               ❯
//             </button>
//           </>
//         )}

//  {/* Dots */}
//         <div className="image-dots">
//           {images.slice(0, 5).map((_, i) => (
//             <span
//               key={i}
//               className={`dot ${i === activeIndex ? "active" : ""}`}
//               onClick={() => setActiveIndex(i)}
//             />
//           ))}
//         </div>

//       </div>

//       {/* Details */}
//       <div className="hotel-details">
//         <h2 className="hotel-title">
//           {property?.propertyName || "Hotel Name"}{" "}
//           <span className="stars">{"★".repeat(property?.stars || 2)}</span>
//         </h2>
//         <p className="hotel-location">
//           {property?.city || "City"} · <a href="#">Show on map</a> ·{" "}
//           {/* {property?.distanceFromCenter || "0 km"} from downtown */}
//         </p>

//         {/* <div className="room-info">
//           <p className="room-name">{roomDetails?.roomName || "Standard Room"}</p>
//           <p>{room?.bedroomBeds?.double || 1} full bed</p>
//         </div> */}

//         <div className="room-info">
//   <p className="room-name">{roomDetails?.roomName || "Standard Room"}</p>

//   {/* Bedroom Beds */}
//   {room?.bedroomBeds && (
//     <p>
//       {Object.entries(room.bedroomBeds)
//         .filter(([type, count]) => count > 0) // sirf wo beds jisme count > 0 hai
//         .map(([type, count]) => `${count} ${type} bed${count > 1 ? "s" : ""}`)
//         .join(", ")}
//     </p>
//   )}

//   {/* Living Room Beds */}
//   {room?.livingRoomBeds && (
//     <p>
//       {Object.entries(room.livingRoomBeds)
//         .filter(([type, count]) => count > 0)
//         .map(([type, count]) => `${count} ${type}${count > 1 ? "s" : ""}`)
//         .join(", ")}
//     </p>
//   )}
// </div>


//         <div className="features">
//           {room?.breakfast?.available && (
//             <p className="breakfast">
//               {room.breakfast.included
//                 ? "Breakfast included"
//                 : `Breakfast available (${room.breakfast.price})`}
//             </p>
//           )}
//           <p className="green">✔ Free cancellation</p>
//           {/* <p className="green">✔ No prepayment needed – pay at the property</p> */}
//           <p className="red">
//             Only {roomDetails?.noOfRooms || 1} rooms left at this price on our site
//           </p>
//         </div>
//       </div>

//       {/* Price / Action */}
//       <div className="hotel-price">
//         {property?.isNew && (
//           <span className="badge">New to Booking.com</span>
//         )}

//         {/* <p className="nights">5 nights, 2 adults</p> */}
//         <p className="nights">
//   {nights} night{nights > 1 ? "s" : ""},{" "}
//   {bookingData?.adults || 0} adults
//   {bookingData?.children > 0 ? `, ${bookingData.children} children` : ""}
//   {bookingData?.rooms ? ` · ${bookingData.rooms} room(s)` : ""}
// </p>

// <p className="price">
//   PKR{" "}
//   {activeDiscount
//     ? activeDiscount.discountPrice
//     : room?.nightlyPrice || "N/A"}
// </p>

// {activeDiscount && (
//   <p className="tax">
//     <s>PKR {room?.nightlyPrice}</s> (discount applied: {activeDiscount.discountPercentage}%)
//   </p>
// )}



        
//         <p className="tax">+ PKR {room?.tax || 0} taxes and fees</p>

//         <button className="availability-btn" onClick={()=>handleAvailabilityClick()}>See availability</button>
//       </div>
//     </div>


//   );
// };

// export default HotelCard;








































// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";

// import "./HotelCard.css";

// const HotelCard = ({ property }) => {
//   const navigate = useNavigate();

//   const [activeIndex, setActiveIndex] = useState(0);

//   // Filter approved rooms
//   const approvedRooms = property?.rooms
//     ? property.rooms.filter((room) => room.status === "approved")
//     : [];

//   const isApproved =
//     property?.status === "approved" && approvedRooms.length > 0;

//   // Images
//   const room = isApproved ? approvedRooms[0] : null;
//   const roomDetails = room?.roomDetails || {};
//   const images =
//     room?.roomImages?.length > 0 ? room.roomImages : property?.images || [];

//   useEffect(() => {
//     if (images.length > 1) {
//       const timer = setInterval(() => {
//         setActiveIndex((prev) => (prev + 1) % images.length);
//       }, 3000);
//       return () => clearInterval(timer);
//     }
//   }, [images]);

//   // If not approved, return null here (AFTER hooks are declared)
//   if (!isApproved) return null;
 



//   // Image navigation
//   const nextImage = () => {
//     setActiveIndex((prev) => (prev + 1) % images.length);
//   };

//   const prevImage = () => {
//     setActiveIndex((prev) => (prev - 1 + images.length) % images.length);
//   };

//   // Slug generator
//   const toSlug = (name) => {
//     if (!name) return "unknown";
//     return name
//       .trim()
//       .toLowerCase()
//       .replace(/%20/g, "-")
//       .replace(/\s+/g, "-")
//       .replace(/-+/g, "-");
//   };

//   // Navigate to details page
//   const handleAvailabilityClick = () => {
//     navigate(`/property/${toSlug(property.propertyName)}`, {
//       state: { property },
//     });
//   };

//   return (
//     <div className="hotel-card">
//       {/* Image Slider */}
//       <div className="hotel-image">
//         <img
//           src={
//             images[activeIndex] ||
//             "https://cf.bstatic.com/xdata/images/hotel/square240/728776239.webp"
//           }
//           alt={property?.propertyName || "Hotel"}
//         />

//         {/* Navigation Arrows */}
//         {images.length > 1 && (
//           <>
//             <button className="arrow prev" onClick={prevImage}>
//               ❮
//             </button>
//             <button className="arrow next" onClick={nextImage}>
//               ❯
//             </button>
//           </>
//         )}

//         {/* Dots */}
//         <div className="image-dots">
//           {images.slice(0, 5).map((_, i) => (
//             <span
//               key={i}
//               className={`dot ${i === activeIndex ? "active" : ""}`}
//               onClick={() => setActiveIndex(i)}
//             />
//           ))}
//         </div>
//       </div>

//       {/* Details */}
//       <div className="hotel-details">
//         <h2 className="hotel-title">
//           {property?.propertyName || "Hotel Name"}{" "}
//           <span className="stars">{"★".repeat(property?.stars || 2)}</span>
//         </h2>
//         <p className="hotel-location">
//           {property?.city || "City"} · <a href="#">Show on map</a> ·{" "}
//           {property?.distanceFromCenter || "0 km"} from downtown
//         </p>

//         <div className="room-info">
//           <p className="room-name">{roomDetails?.roomName || "Standard Room"}</p>
//           <p>{room?.bedroomBeds?.double || 1} full bed</p>
//         </div>

//         <div className="features">
//           {room?.breakfast?.available && (
//             <p className="breakfast">
//               {room.breakfast.included
//                 ? "Breakfast included"
//                 : `Breakfast available (${room.breakfast.price})`}
//             </p>
//           )}
//           <p className="green">✔ Free cancellation</p>
//           <p className="red">
//             Only {roomDetails?.noOfRooms || 1} rooms left at this price on our site
//           </p>
//         </div>
//       </div>

//       {/* Price / Action */}
//       <div className="hotel-price">
//         {property?.isNew && <span className="badge">New to Booking.com</span>}

//         <p className="nights">5 nights, 2 adults</p>
//         <p className="price">
//           PKR{" "}
//           {room?.discount?.isDiscountActive
//             ? room.discount.priceAfterDiscount
//             : room?.nightlyPrice || "N/A"}
//         </p>
//         {room?.discount?.isDiscountActive && (
//           <p className="tax">
//             <s>PKR {room?.nightlyPrice}</s> (discount applied)
//           </p>
//         )}
//         <p className="tax">+ PKR {room?.taxes || 0} taxes and fees</p>

//         <button className="availability-btn" onClick={handleAvailabilityClick}>
//           See availability
//         </button>
//       </div>
//     </div>
//   );
// };

// export default HotelCard;